import { render, staticRenderFns } from "./AddressReadOnly.vue?vue&type=template&id=79474ce7&scoped=true&"
import script from "./AddressReadOnly.vue?vue&type=script&lang=js&"
export * from "./AddressReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./AddressReadOnly.vue?vue&type=style&index=0&id=79474ce7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79474ce7",
  null
  
)

export default component.exports